// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about{
    width: 100%;  
    height: auto;
background-color: e0f7fa;
margin: 0;
padding: 0;
overflow: hidden; /* Hides any overflow content */

}

.innerAbout
{
    width: 55%;
    padding-top:5% ;
    margin-left: 20%;
    text-align: left;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.mainHeading
{
    font-family: 'VanillaMilk';
    font-size: 35px;
    color: #8b0194;
    text-align: center;
    z-index: 1;
    padding: 20px;
}

.para
{
    font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-size:18px; 
    text-align: left;
    color: #000000; 

    z-index: 1; 
}
.owner
{
    width: 100%;
    height: auto;
    background-color: #f0eded;
}

@media only screen and (max-width: 1000px)
{
    .innerAbout{
        width: -webkit-fill-available;
        margin-left: 0;
    }
}
`, "",{"version":3,"sources":["webpack://./src/MyComponents/FooterPages/AboutUs.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;AAChB,wBAAwB;AACxB,SAAS;AACT,UAAU;AACV,gBAAgB,EAAE,+BAA+B;;AAEjD;;AAEA;;IAEI,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;;IAEI,0BAA0B;IAC1B,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,aAAa;AACjB;;AAEA;;IAEI,2DAA2D;IAC3D,cAAc;IACd,gBAAgB;IAChB,cAAc;;IAEd,UAAU;AACd;AACA;;IAEI,WAAW;IACX,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;IAEI;QACI,6BAA6B;QAC7B,cAAc;IAClB;AACJ","sourcesContent":[".about{\n    width: 100%;  \n    height: auto;\nbackground-color: e0f7fa;\nmargin: 0;\npadding: 0;\noverflow: hidden; /* Hides any overflow content */\n\n}\n\n.innerAbout\n{\n    width: 55%;\n    padding-top:5% ;\n    margin-left: 20%;\n    text-align: left;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n.mainHeading\n{\n    font-family: 'VanillaMilk';\n    font-size: 35px;\n    color: #8b0194;\n    text-align: center;\n    z-index: 1;\n    padding: 20px;\n}\n\n.para\n{\n    font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    font-size:18px; \n    text-align: left;\n    color: #000000; \n\n    z-index: 1; \n}\n.owner\n{\n    width: 100%;\n    height: auto;\n    background-color: #f0eded;\n}\n\n@media only screen and (max-width: 1000px)\n{\n    .innerAbout{\n        width: -webkit-fill-available;\n        margin-left: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
